import { AppConfig, ENVIRONMENT } from 'types';
import { API_URL_DEV, API_URL_DEV_EMPLOYEE, buildAPI } from 'consts';

const IS_EMPLOYEE_WEB = false;
const API_URL = IS_EMPLOYEE_WEB ? API_URL_DEV_EMPLOYEE : API_URL_DEV;
const API = buildAPI(API_URL);

export const DEFAULT_APP_CONFIG: AppConfig = {
	API_CONTENT_URL: API.external.contentApi,
	API_DIGITAL_SIGNATURE_URL: API.external.digitalSignature(ENVIRONMENT.TEST),
	API_URL,
	API,
	APP_ENV: ENVIRONMENT.DEVELOPMENT,
	CURITY_AUTHORIZATION_URL: 'https://curity-dev.arionbanki.is/oauth/v2/oauth-authorize',
	CURITY_CLIENT_ID: 'ipa-employeeweb-ui',
	CURITY_CLIENT_SECRET: '4LmA4QgEZ1HjIR275vMrrTFfVkJOyitnoIM6q6m3xs8hGxLVylrUuyFzoD44m3cM_4lkyhTJbs9avEPWEnp47Q',
	CURITY_METADATA_URL: 'https://curity-dev.arionbanki.is/oauth/v2/oauth-anonymous/.well-known/openid-configuration',
	CURITY_OAUTH_TOKEN_URL: 'https://curity-dev.arionbanki.is/oauth/v2/oauth-token',
	ENABLE_RESET_VIEW: true,
	IS_ALLOWED_TO_CHANGE_LANGUAGE: true,
	IS_EMPLOYEE_WEB
};
